/** Tooltip on every write control a read-only caller sees disabled (#296). */
export const READ_ONLY_HINT = 'You have read-only access to this project';

export function ReadOnlyBadge() {
  return (
    <span className="badge badge-ghost badge-sm" title={READ_ONLY_HINT}>
      Read-only
    </span>
  );
}
